import { StrictMode } from 'react';

import { ErrorBoundary } from 'react-error-boundary';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { createRoot } from 'react-dom/client';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import '@/api/ffne/ffneApi';

import { router } from './app/router';
import { Toast } from './components/atoms/Toast';
import ErrorFallback from './components/ErrorFallback';
import { store } from './store';
import theme from './theme';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RouterProvider router={router} />
          <Toast />
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  </StrictMode>,
);
